module.exports = __webpack_public_path__ + "img/middletonl.492d6731.jpg";